import type { Fundraising } from "../../../../../api/types/fundraisingTypes";
import type { DialogState } from "../fundraisingsPageTypes";
import ChangeFundraisingStatusDialog from "./ChangeFundraisingStatusDialog";
import ConfirmSaveFundraisingDialog from "./ConfirmSaveFundraisingDialog";
import DeleteFundraisingDialog from "./DeleteFundraisingDialog";
import EditFundraisingDialog from "./EditFundraisingDialog";

interface Props {
  dialogState: DialogState;
  onCreated: (fundraising: Fundraising) => void;
  onUpdated: (fundraising: Fundraising) => void;
  onDeleted: () => void;
  onClose: () => void;
}

const FundraisingDialogs = ({ dialogState, onCreated, onUpdated, onDeleted, onClose }: Props) => {
  return (
    <>
      {dialogState.openDialog === "create" && (
        <EditFundraisingDialog onCreated={onCreated} onUpdated={onUpdated} onClose={onClose} />
      )}

      {dialogState.openDialog === "rename" && dialogState.fundraisingId && dialogState.fundraisingName && (
        <EditFundraisingDialog
          fundraisingId={dialogState.fundraisingId}
          fundraisingEtag={dialogState.fundraisingEtag}
          fundraisingName={dialogState.fundraisingName}
          onCreated={onCreated}
          onUpdated={onUpdated}
          onClose={onClose}
        />
      )}

      {dialogState.openDialog === "change_status" && dialogState.statusTransition && dialogState.fundraisingId && (
        <ChangeFundraisingStatusDialog
          fundraisingId={dialogState.fundraisingId}
          fundraisingEtag={dialogState.fundraisingEtag}
          fundId={dialogState.fundId}
          statusTransition={dialogState.statusTransition}
          areNotificationsSetUp={dialogState.areNotificationsSetUp}
          onUpdated={onUpdated}
          onClose={onClose}
        />
      )}

      {dialogState.openDialog === "delete" && dialogState.fundraisingId && dialogState.fundraisingName && (
        <DeleteFundraisingDialog
          fundraisingId={dialogState.fundraisingId}
          fundraisingName={dialogState.fundraisingName}
          onDeleted={onDeleted}
          onClose={onClose}
        />
      )}

      {dialogState.openDialog === "confirm_save" && dialogState.onSaveConfirmed && (
        <ConfirmSaveFundraisingDialog
          onSaveConfirmed={() => {
            onClose();
            dialogState.onSaveConfirmed?.();
          }}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default FundraisingDialogs;
